<template>
	<Overlay :value="value" class="loader">
		<img class="gear" src="@/assets/gear.svg"/>
	</Overlay>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import Overlay from '@/components/gui/Overlay.vue'

export default defineComponent({
	name: 'Loader',

	components: {
		Overlay
	},

	props: {
		value: Boolean
	}
})
</script>

<style lang="scss" scoped>
.loader {
	.gear {
		margin: auto; 
		background: rgba(255, 255, 255, 0) none repeat scroll 0% 0%; 
		display: block; 
		shape-rendering: auto;
		width: 120px;
		height: 120px;
		opacity: 0.5;
	}
}
</style>
